import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { init, miniApp, swipeBehavior, retrieveRawInitData } from '@telegram-apps/sdk'

// Import pages
import MiniApp from './pages/MiniApp'
import SearchUsers from './pages/SearchUsers'
import UserDetails from './pages/UserDetails'
import RandomCoffee from './pages/RandomCoffee'
import { ErrorBoundary } from './components/ErrorBoundary'

function App() {
  useEffect(() => {
    // Initialize Telegram SDK
    init()

    // Send user ID to Yandex Metrica
    const initDataRaw = new URLSearchParams(retrieveRawInitData() ?? '')
    const user = JSON.parse(initDataRaw.get('user') ?? '{}')

    if (user.id && window.ym) {
      window.ym(103622962, 'userParams', {
        UserID: user.id,
      })
    }

    // Mount Telegram mini app
    if (miniApp.mount.isAvailable()) miniApp.mount()
    if (miniApp.ready.isAvailable()) miniApp.ready()
    if (swipeBehavior.mount.isAvailable()) swipeBehavior.mount()
  }, [])

  return (
    <Router basename="/miniapp">
      <Routes>
        <Route 
          path="/" 
          element={
            <ErrorBoundary fallbackTitle="Ошибка на главной странице">
              <MiniApp />
            </ErrorBoundary>
          } 
        />
        <Route 
          path="/search" 
          element={
            <ErrorBoundary fallbackTitle="Ошибка поиска">
              <SearchUsers />
            </ErrorBoundary>
          } 
        />
        <Route 
          path="/users/:userId/details" 
          element={
            <ErrorBoundary fallbackTitle="Ошибка профиля пользователя">
              <UserDetails />
            </ErrorBoundary>
          } 
        />
        <Route 
          path="/random-coffee" 
          element={
            <ErrorBoundary fallbackTitle="Ошибка Random Coffee">
              <RandomCoffee />
            </ErrorBoundary>
          } 
        />
      </Routes>
    </Router>
  )
}

export default App
